import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import LECollectionSearch from "./routes/LECollectionSearchPage";
import LESearch from "./routes/LESearchPage";
import UnitSearch from "./routes/UnitSearchPage";
import WorksheetSearch from "./routes/WorksheetSearchPage";
import MockExamSearch from "./routes/MockExamSearchPage";
import QuestionSearch from "./routes/QuestionsSearchPage";
export default store => {
  return {
    path: "search/:searchText",
    component: withAsyncRouteLoading(
      () =>
        Promise.all([
          import(/* webpackChunkName: "toddle-library" */ "./components"),
        ]).then(([importedModule0]) => {
          const component = importedModule0.default;
          return component;
        })
      // .catch(err => {
      //   throw err;
      // })
    ),
    childRoutes: [
      LECollectionSearch(store),
      LESearch(store),
      UnitSearch(store),
      WorksheetSearch(store),
      MockExamSearch(store),
      QuestionSearch(store),
    ],
  };
};
